import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const services = [
    { label: 'CRM', to: '/services#crm' },
    { label: 'Marketing', to: '/services#marketing' },
    { label: t('services.sales.title'), to: '/services#sales' },
    { label: t('services.service.title'), to: '/services#service' },
  ];

  const company = [
    { label: t('nav.about'), to: '/about' },
    { label: t('nav.contact'), to: '/contact' },
  ];

  const legal = [
    { label: t('footer.privacy'), to: '#' },
    { label: t('footer.terms'), to: '#' },
    { label: t('footer.cookies'), to: '#' },
  ];

  return (
    <footer className="bg-[#F5F5F7] border-t border-slate-200" data-testid="footer">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_ced1def1-5c79-41a6-a911-205351f73e31/artifacts/90ux9tsg_v...%202.PNG"
                alt="VSP Logo"
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-semibold text-[#1D1D1F] tracking-tight font-['Plus_Jakarta_Sans']">
                VSP
              </span>
            </Link>
            <p className="text-sm text-[#86868B] leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
            <div className="space-y-3">
              <a
                href="mailto:contact@corpvictory.com"
                className="flex items-center gap-3 text-sm text-[#1D1D1F] hover:text-[#007AFF] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#86868B]" />
                contact@corpvictory.com
              </a>
              <a
                href="tel:+442921680168"
                className="flex items-center gap-3 text-sm text-[#1D1D1F] hover:text-[#007AFF] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#86868B]" />
                +44 (0)29 2168 0168
              </a>
              <div className="flex items-start gap-3 text-sm text-[#1D1D1F]">
                <MapPin className="w-4 h-4 text-[#86868B] mt-0.5" />
                <span>20-22 Wenlock Road<br />London N1 7GU, UK</span>
              </div>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-sm font-semibold text-[#1D1D1F] uppercase tracking-wider mb-4 font-['Plus_Jakarta_Sans']">
              {t('footer.services')}
            </h4>
            <ul className="space-y-3">
              {services.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-[#86868B] hover:text-[#007AFF] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-sm font-semibold text-[#1D1D1F] uppercase tracking-wider mb-4 font-['Plus_Jakarta_Sans']">
              {t('footer.company')}
            </h4>
            <ul className="space-y-3">
              {company.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-[#86868B] hover:text-[#007AFF] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-sm font-semibold text-[#1D1D1F] uppercase tracking-wider mb-4 font-['Plus_Jakarta_Sans']">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-3">
              {legal.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-[#86868B] hover:text-[#007AFF] transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#86868B]">
              &copy; {currentYear} Victory Service Provider LTD. {t('footer.rights')}
            </p>
            <div className="flex items-center gap-2">
              <span className="text-xs text-[#86868B]">EU Market Focus</span>
              <span className="inline-flex items-center px-2 py-1 rounded-full bg-[#E8E8ED] text-xs font-medium text-[#1D1D1F]">
                GDPR Compliant
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
